const urlSearchParams = new URLSearchParams(location.search);

class QueryParams {
	// no used at the moment, but can be helpful
	getBoolean(name: string, defaultValue: boolean) {
		const emulateOpenValue = urlSearchParams.get(name);
		if (emulateOpenValue) {
			try {
				return !!JSON.parse(emulateOpenValue);
			}
			catch (error) {
				// fall through
			}
		}
		return defaultValue;
	}

	get(name: string) {
		return urlSearchParams.get(name);
	}
}

export const queryParams = new QueryParams();
